import * as DrillThroughConstants from './DrillThroughConstants';
import { produce } from "immer";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isfaileCalibdataFetched: false,
    isfaileCalibdataFetching: false,
    isfaileCalibdataFetchingFailed: false,
    isfaileQCdataFetched: false,
    isfaileQCdataFetching: false,
    isfaileQCdataFetchingFailed: false,
    calibData: [],
    qcData:[]
}

export default function DrillThroughReducer(state = initialState, action) {

    switch (action.type) {

        case  DrillThroughConstants.DT_DEVICE_STATE_ADD: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isfaileCalibdataFetched: false,
                    isfaileCalibdataFetching: false,
                    isfaileCalibdataFetchingFailed: false,
                    isfaileQCdataFetched: false,
                    isfaileQCdataFetching: false,
                    isfaileQCdataFetchingFailed: false,
                    calibData: [],
                    qcData:[]
                }
            });
            return assign({}, state, newState);
        }

        case DrillThroughConstants.DT_CALIB_DATA_FETCHING:{
             const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isfaileCalibdataFetched: false,
                    isfaileCalibdataFetching: true,
                    isfaileCalibdataFetchingFailed: false,
                    isfaileQCdataFetched: false,
                    isfaileQCdataFetching: false,
                    isfaileQCdataFetchingFailed: false,
                    calibData: [],
                    qcData:[]
                }
            });
            return assign({}, state,newState);
        }
        
        case DrillThroughConstants.DT_CALIB_DATA_FETCHED:{
            
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    isfaileCalibdataFetched: true,
                    isfaileCalibdataFetching: false,
                    isfaileCalibdataFetchingFailed: false,
                    calibData:action.payload.newState.result,
                    isfaileQCdataFetched: false,
                    isfaileQCdataFetching: false,
                    isfaileQCdataFetchingFailed: false
                }
            });

            return assign({}, state,newState);
        }

        case DrillThroughConstants.DT_CALIB_DATA_FETCHED_FAILED:{
           const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isfaileCalibdataFetched: false,
                    isfaileCalibdataFetching: false,
                    isfaileCalibdataFetchingFailed: true,
                    isfaileQCdataFetched: false,
                    isfaileQCdataFetching: false,
                    isfaileQCdataFetchingFailed: false,
                    calibData: [],
                    qcData:[]
                }
            });

            return assign({}, state,newState);
        }
        case DrillThroughConstants.DT_QC_DATA_FETCHING:{

            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isfaileQCdataFetched: false,
                    isfaileQCdataFetching: true,
                    isfaileQCdataFetchingFailed: false,
                    isfaileCalibdataFetched: false,
                    isfaileCalibdataFetching: false,
                    isfaileCalibdataFetchingFailed: false,
                    calibData: [],
                    qcData:[]
                }
            });
            return assign({}, state,newState);
        }
            
        case DrillThroughConstants.DT_QC_DATA_FETCHED:{
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    isfaileQCdataFetched: true,
                    isfaileQCdataFetching: false,
                    isfaileQCdataFetchingFailed: false,
                    qcData:action.payload.newState.result,
                    isfaileCalibdataFetched: false,
                    isfaileCalibdataFetching: false,
                    isfaileCalibdataFetchingFailed: false
                }
            });

            return assign({}, state,newState);
 
        }   
        
        case DrillThroughConstants.DT_QC_DATA_FETCHED_FAILED:{

            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isfaileQCdataFetched: false,
                    isfaileQCdataFetching: false,
                    isfaileQCdataFetchingFailed: true,
                    isfaileCalibdataFetched: false,
                    isfaileCalibdataFetching: false,
                    isfaileCalibdataFetchingFailed: false,
                    calibData: [],
                    qcData:[]
                }
            });

            return assign({}, state,newState);
        } 
        break;   
        
        default:
        return state;

    }

}